export const WORKSPACE_LINE_PLOT_SETTINGS_DESCRIPTION =
  'Set global defaults for line plots in this workspace.';
